<app-shared-loading *ngIf="loading"></app-shared-loading>
<app-return-methods
  [itsMobileCtrl]="true"
  [unique]="this.transaction.ORDER_METHOD"
  (RT)="changeMethod()"
></app-return-methods>
<div class="general-title">
  <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>
<div
  *ngIf="user != CONCEPTS.CASH && user != CONCEPTS.TRANSFER && user != CONCEPTS.TRANSFER_SINPE && user != CONCEPTS.DEPOSIT"
  class="contentBox">
  <div class="column">
    <div class="titleContainer">
      <h1 class="center" *ngIf="info.category !== '7'; else subtitleCRC ">{{ 'cash-Option' | translation | async }}</h1>
      <ng-template #subtitleCRC><h1 class="center">{{ 'cashTransferSubtitle' | translation | async }}</h1></ng-template>
    </div>
    <div class="optionsContainer">
      <app-return-methods
        class="pl-2"
        [itsMobileCtrl]="false"
        [unique]="this.transaction.ORDER_METHOD"
        (RT)="changeMethod()"
      ></app-return-methods>
      <div class="containerButtons">
        <div *ngFor="let concept of info.concept">
          <app-selection-button *ngIf="concept.type == 'Efectivo en Agente'" text="Efectivo en Agente"
                                (click)="setUser(CONCEPTS.CASH); currentConcept= concept"></app-selection-button>
          <app-selection-button *ngIf="concept.type == 'Trasferencias por Web'" text="Transferencias por Web"
                                (click)="setUser(CONCEPTS.TRANSFER); currentConcept= concept"></app-selection-button>
          <app-selection-button *ngIf="concept.type == 'Deposito'" text="Depósito"
                                (click)="setUser(CONCEPTS.DEPOSIT); currentConcept= concept"></app-selection-button>
          <ng-container *ngIf="info.category !== '7'; else isCRCButtons">
            <app-selection-button *ngIf="concept.type == 'Deposito en Colones'"
                                  [text]="('cashDepositColones' | translation | async)"
                                  (click)="setUser(CONCEPTS.DEPOSIT); currentConcept= concept"></app-selection-button>
            <app-selection-button *ngIf="concept.type == 'Deposito en Dolares'"
                                  [text]="('cashDepositDollars' | translation | async)"
                                  (click)="setUser(CONCEPTS.DEPOSIT); currentConcept= concept"></app-selection-button>
          </ng-container>
          <ng-template #isCRCButtons>
            <app-selection-button *ngIf="concept.type == 'Deposito en Colones'"
                                  [text]="('cashTransferColones' | translation | async)"
                                  (click)="setUser(CONCEPTS.TRANSFER_SINPE); currentConcept= concept"></app-selection-button>
            <app-selection-button *ngIf="concept.type == 'Deposito en Dolares'"
                                  [text]="('cashTransferDollars' | translation | async)"
                                  (click)="setUser(CONCEPTS.TRANSFER_SINPE); currentConcept= concept"></app-selection-button>
          </ng-template>

        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="user == CONCEPTS.CASH || user == CONCEPTS.TRANSFER || user == CONCEPTS.DEPOSIT || user == CONCEPTS.TRANSFER_SINPE"
  class="contentBox">
  <div class="col-3">
    <div class="info-logo-container">
      <img src="{{ info.logo }}" class="payment_method_no_interactive" alt="Logo de la red de pago en efectivo"/>
    </div>
    <h2 *ngIf="country!='COP' && country!='PEN'">{{user}}</h2>
  </div>
  <div class="col-7">
    <div class="methodInfo">
      <app-return-methods
        *ngIf="visibleReturnPayMethods"
        [itsMobileCtrl]="false"
        [unique]="''"
        (RT)="changeMethod()"
      ></app-return-methods>
      <ng-container *ngIf="!isCashRobot; else depositRobot" #printCash>
        <div *ngIf="user == CONCEPTS.CASH">
          <!-- EFECTIVO -->
          <app-efectivo [info]="info" [transaction]="transaction" [currentConcept]="currentConcept"></app-efectivo>
        </div>
        <div *ngIf="user == CONCEPTS.TRANSFER">
          <app-transfer-instructions [transaction]="transaction"
                                     [info]="info"
                                     [currentConcept]="currentConcept"
                                     [transferNetworkCode]="transferNetworkCode"></app-transfer-instructions>
        </div>
        <div *ngIf="user == CONCEPTS.DEPOSIT">
          <app-deposit [info]="info" [currentConcept]="currentConcept"></app-deposit>
          <br>
          <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
        </div>
        <div *ngIf="user == CONCEPTS.TRANSFER_SINPE">
          <app-transfer [info]="info" [currentConcept]="currentConcept"></app-transfer>
        </div>
      </ng-container>
      <ng-template #depositRobot>
        <app-cash-robot (changeMethod)="changeRobotMethod()"></app-cash-robot>
      </ng-template>
    </div>
    <app-buttons-bar [template]="template" [valid]="completedForms()" *ngIf="!isCashRobot && user != CONCEPTS.CASH"
                     [nameCustom]="user=='Depósito'||user==CONCEPTS.TRANSFER_SINPE||user===CONCEPTS.TRANSFER? 'Enviar':'¡Gracias!'"
                     (CUSTOM)="finalize()">
    </app-buttons-bar>
    <ng-container *ngIf="(user == CONCEPTS.CASH || user == CONCEPTS.DEPOSIT) && merchantHasWallet && bannerRecommedationFF && bannerRecommedationUiFixFF">
      <div [ngClass]="{'recomendationBannerMobileClassDeposit': bannerRecommedationUiFixFF && user == CONCEPTS.DEPOSIT,
                      'recomendationBannerMobileClassCash': bannerRecommedationUiFixFF && user == CONCEPTS.CASH }">
        <app-recommendations-banner [bannerText]="bannerText"></app-recommendations-banner>
      </div>
    </ng-container>
  </div>
</div>

<br>
<ng-container *ngIf="(user == CONCEPTS.CASH || user == CONCEPTS.DEPOSIT) && merchantHasWallet && bannerRecommedationFF">
  <div [ngClass]="{'recomendationBannerClass': bannerRecommedationUiFixFF}">
    <app-recommendations-banner [bannerText]="bannerText"></app-recommendations-banner>
  </div>
</ng-container>
